module.exports = __webpack_public_path__ + "img/291.57d1abf1.jpg";